"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
exports.footer = {
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: widgets_1.TabStyles.Spacing.DefaultSpace,
};
exports.managePermissionsButton = {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'flex-beginning',
};
exports.rightButtons = {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'flex-end',
};
//# sourceMappingURL=GrantPermissionsDialogStyle.js.map